import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { useEffect, useState } from 'react';

interface SimpleDialogProps {
  open: boolean;
  onSave: any;
  onClose: () => void;
  invoices: any;
  ordersDetailsActual?: any[];
}

type Products = {
  id: number;
  name: string;
  quantity: number;
};

const keyProducts: (keyof Products)[] = ['name', 'quantity'];
export function CanceledProducts(props: SimpleDialogProps) {
  const { onClose, open, invoices, onSave, ordersDetailsActual } = props;

  const [saveProductDelete, setSaveProductDelete] = useState<{
    [key: string]: string;
  }>({});
  const handleClose = () => {
    onClose();
  };

  const [allOrderModification, setAllOrderModification] = useState<any[]>([]);
  const { typography } = useTheme();

  const handleSubmit = async () => {
    try {
      const logProductsCanceled = allOrderModification.map((orderDetail: any) => ({
        orderId: invoices.orderId,
        productId: orderDetail.id,
        productName: orderDetail.name,
        quantity: orderDetail.quantity,
        vendorId: invoices.vendor.id,
        vendorName: invoices.vendor.name,
        description: saveProductDelete[orderDetail.id],
      }));
      await onSave({ list: logProductsCanceled }, true);
      
      handleClose();
    } catch (error) {
      console.log('🚀 ~ file: canceledProducts.tsx ~ handleSubmit ~ error', error);
      
      
    }
  };

  useEffect(() => {
    if (ordersDetailsActual && invoices?.items) {
      const removeAllProducts: any[] = [];
      const removeSomeProducts: any[] = [];

      ordersDetailsActual.forEach((orderDetail) => {
        if (
          !invoices.items.some(
            (invoice: any) =>
              invoice.product.value === orderDetail.product.product.id && invoice.id === orderDetail.id
          )
        ) {
          removeAllProducts.push(orderDetail);
        } else {
          const orderDetailEdit = invoices.items.find(
            (item: any) => item.product.value === orderDetail.product.product.id
          );
          if (orderDetail.quantity > orderDetailEdit.quantity) {
            removeSomeProducts.push({
              ...orderDetail,
              quantity: orderDetail.quantity - orderDetailEdit.quantity,
            });
          }
        }
      });
      if (removeAllProducts.length > 0 || removeSomeProducts.length > 0) {
        setAllOrderModification(
          [...removeAllProducts, ...removeSomeProducts].map((orderStacked) => ({
            id: orderStacked.product.product.id,
            name: orderStacked.product.product.name,
            quantity: orderStacked.quantity,
          }))
        );
      } else {
        setAllOrderModification([]);
      }
    }
  }, [invoices, ordersDetailsActual]);

  const handleTextField = (e: any, id: number) => {
    setSaveProductDelete((prev) => ({ ...prev, [id]: e.target.value }));
  };
  return (
    <Dialog onClose={handleClose} open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography sx={{ ...typography.h6 }} textAlign="center">
          Productos Eliminados
        </Typography>
      </DialogTitle>
      <DialogContent>
        {allOrderModification?.map((product: Products, keyP: number) => (
          <Card>
            <CardHeader title={product.name} />

            <CardContent>
              {keyProducts.map((key) => (
                <Stack sx={{ display: 'flex', flexDirection: 'row', gap: '0.5rem' }}>
                  <Typography variant="body2">{key} : </Typography>
                  <Typography variant="subtitle2">{product[key]}</Typography>
                </Stack>
              ))}
              <TextField
                name={`description-${keyP}`}
                variant="outlined"
                type="text"
                label="Observacion"
                fullWidth
                required
                onChange={(e) => handleTextField(e, product.id)}
              />
            </CardContent>
          </Card>
        ))}
        <DialogActions>
          <Button  onClick={handleSubmit}>
            Guardar
          </Button>
          <Button  onClick={onClose}>
            Cancelar
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
